import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
/* For localization start*/
import { TranslateModule } from '@ngx-translate/core';
/* For localization end*/

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    LoaderComponent,
  ],
  exports: [LoaderComponent]
})
export class LoaderModule { }
